export default __webpack_public_path__ + "static/media/logo-blue.0e66073c.svg";